import React, { useState } from 'react'
import { useAccessibility } from '../utils/useAccessibility'

export const Navbar: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const { preferences, toggleDyslexicFont, toggleHighContrast } = useAccessibility()

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img 
          src="logo_olecio.png" 
          alt="Olecio" 
          className="navbar-logo"
        />
      </div>
      
      <div className="navbar-actions">
        <div className="accessibility-menu">
          <button
            className="accessibility-toggle"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            aria-label="Menu d'accessibilité"
            aria-expanded={isDropdownOpen}
          >
            <i className="fas fa-universal-access"></i>
          </button>
          
          {isDropdownOpen && (
            <div className="accessibility-dropdown">
              <div className="accessibility-option">
                <span className="accessibility-label">Police dyslexique</span>
                <button
                  className={`accessibility-switch ${preferences.dyslexicFont ? 'active' : ''}`}
                  onClick={toggleDyslexicFont}
                  aria-label={`${preferences.dyslexicFont ? 'Désactiver' : 'Activer'} la police dyslexique`}
                />
              </div>
              
              <div className="accessibility-option">
                <span className="accessibility-label">Contraste élevé</span>
                <button
                  className={`accessibility-switch ${preferences.highContrast ? 'active' : ''}`}
                  onClick={toggleHighContrast}
                  aria-label={`${preferences.highContrast ? 'Désactiver' : 'Activer'} le contraste élevé`}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}
